export default __webpack_public_path__ + "static/Mdrouz-55ce251e74a5384361a19674d7c94b42.mp4";